import api from "../services/api";
import backEnd from "../constants/backEnd";
import endpoints from "../constants/endpoints";

export async function getUserDetail(json) {
    return api
        .get(`${backEnd.url}${endpoints.access.user}`)
        .then((response) => {
            return { type: "success", data: response.data };
        })
        .catch((error) => {
            return {
                type: "error",
                data: {
                    code: error?.response?.data?.code || "unknown_error",
                    detail: error?.response?.data?.detail || "An error occurred",
                },
            };
        });
}
